/* file description */
import React from 'react';
import OpenApiSelectModalMemo from './../component/OpenApiSelectModal';
import OpenApiSelectModalRender from './../component/OpenApiSelectModal/render';
import OpenApiSelectMemo from './../component/OpenApiSelect';
// import OpenApiSelectRender from './../component/OpenApiSelect/render';
import { TransformNalmalType2TableColumn } from './type';
import { COLUMN_FROM, VALUE_TYPES, SELECT_MODE } from './consts';
import _ from 'lodash';
import { Input } from 'antd';
import { Api as FetchAPI } from '@/utils';

export const transformOpenApiSelectColumn: TransformNalmalType2TableColumn = ({
  targetColumn,
  field,
  // FetchAPI,
  isMobile,
  moduleInfo,
}) => {
  const { isModal } = field?.bizConfig || {};
  const cloneField = _.cloneDeep(field);
  cloneField.options = field?.bizConfig;
  targetColumn.valueType = VALUE_TYPES.SELECT;

  if (isModal) {
    targetColumn.renderFormItem = (_a, config, form) => {
      if (config.from === 'search') {
        return <Input />;
      }
      return <OpenApiSelectModalMemo moduleInfo={moduleInfo} value={config.value} storeValue={config.storeValue} form={form} config={config} field={cloneField} API={{ FetchAPI }} columnFrom={config.from} rowsData={config.formValue} isMobile={isMobile} />;
    };
    targetColumn.render = (dom, entity) => {
      const targerValue = entity?.value;
      const { setViewValue } = entity;
      return <OpenApiSelectModalRender entity={entity} storeValue={entity.storeValue} columnFrom={entity.from} field={cloneField} API={{ FetchAPI }} targerValue={targerValue} setViewValue={setViewValue} isMobile={isMobile} />;
    };
  } else {
    targetColumn.renderFormItem = (_a, config, form) => {
      if (config.from === 'search') {
        return <Input />;
      }
      return <OpenApiSelectMemo storeValue={config.storeValue} form={form} config={config} field={cloneField} columnFrom={config.from} API={{ FetchAPI }} rowsData={config.formValue} isMobile={isMobile} />;
    };
    targetColumn.render = (dom, entity) => {
      const targerValue = entity?.value;
      return targerValue;
      // return <OpenApiSelectRender field={cloneField} API={{ FetchAPI }} targerValue={targerValue} />;
    };
  }

  return targetColumn;
};
